import { ProductInfo } from '@george-labs.com/design-system';
import type { COLOR } from '@george-labs.com/design-system/types/utilsTS/color';

const PRODUCT_COLORS: Record<string, COLOR> = {
    TEAL: ProductInfo.COLOR.TEAL,
    LAVENDER: ProductInfo.COLOR.LAVENDER,
    FOREST: ProductInfo.COLOR.FOREST,
    HONEY: ProductInfo.COLOR.HONEY,
    CARROT: ProductInfo.COLOR.CARROT,
    ROSE: ProductInfo.COLOR.ROSE,
    BERRY: ProductInfo.COLOR.BERRY,
    POOL: ProductInfo.COLOR.POOL,
    STONE: ProductInfo.COLOR.STONE,
    LIME: ProductInfo.COLOR.LIME,
    LILA: ProductInfo.COLOR.LILA,
    INDIGO: ProductInfo.COLOR.INDIGO,
};

export const FONT_COLORS = {
    BLUE_FONT: '#0065AC',
    RED: '#FF5A54',
    PALETTE_15: '#F6F6F6',
    GREY_200: '#E5E5E5',
};

const FALLBACK_COLOR = ProductInfo.COLOR.WHITE;

export const getColorFromName = (colorName?: string): COLOR => {
    if (!colorName) {
        return FALLBACK_COLOR;
    }

    return PRODUCT_COLORS[colorName.toUpperCase()] || FALLBACK_COLOR;
};
